<div class="container">
  <nav mat-tab-nav-bar class="mat-tab-nav-bar-blue">
    <a
      mat-tab-link
      [routerLink]="['./profile']"
      routerLinkActive
      #rla1="routerLinkActive"
      [active]="rla1.isActive"
    >
      <mat-icon matListIcon>person</mat-icon>&nbsp;&nbsp;&nbsp;Profilo
    </a>
    <a
      mat-tab-link
      [routerLink]="['./destinations']"
      routerLinkActive
      #rla2="routerLinkActive"
      [active]="rla2.isActive"
    >
      <mat-icon matListIcon>place</mat-icon>&nbsp;&nbsp;&nbsp;Destinazioni di
      Competenza
    </a>
    <a
      mat-tab-link
      [routerLink]="['./assignment-proposals']"
      routerLinkActive
      #rla3="routerLinkActive"
      [active]="rla3.isActive"
    >
      <mat-icon matListIcon>move_to_inbox</mat-icon>&nbsp;&nbsp;&nbsp;Proposte
      Assegnazione
    </a>
  </nav>

  <div class="wrapper">
    <router-outlet></router-outlet>
  </div>
</div>
<div style="margin: 16px 0">
  <app-footer-legal></app-footer-legal>
</div>
